import './NeighborhoodGuideContentCard.scss';

interface NeighborhoodGuideContentCardProps {
  children: JSX.Element;
  header: string;
}

function NeighborhoodGuideContentCard(props: NeighborhoodGuideContentCardProps) {
  const { children, header } = props;
  return (
    <div className="neighborhood-guide-card">
      <div className="neighborhood-guide-card-header">{header}</div>
      <div className="neighborhood-guide-card-body">{children}</div>
    </div>
  );
}
export default NeighborhoodGuideContentCard;
